import React from 'react';
import { useEmailVerification } from '../hooks/useEmailVerification';

/**
 * The emailed-code flow that proves an address (#1052), inline on the Account page and in
 * the Pricing page's verify alert (#1130). There is no site-wide banner any more.
 */
const VerifyEmailInline: React.FC<{ onVerified?: () => void }> = ({ onVerified }) => {
  const { phase, resending, code, setCode, error, send, confirm } = useEmailVerification(onVerified);

  if (phase === 'done') return null;

  return (
    <div className="verify-inline">
      {phase === 'entering' || phase === 'confirming' ? (
        <div className="verify-inline-actions">
          <input
            className="acct-input verify-inline-input"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="Enter code"
            aria-label="Verification code"
            // The button that had focus is gone; the code box is the next thing to do.
            autoFocus
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') confirm(); }}
          />
          <button className="btn-primary btn-sm" onClick={confirm} disabled={phase === 'confirming' || !code.trim()}>
            {phase === 'confirming' ? 'Checking…' : 'Confirm'}
          </button>
          <button className="btn-secondary btn-sm" onClick={() => send(true)} disabled={resending || phase === 'confirming'}>
            {resending ? 'Sending…' : 'Resend'}
          </button>
        </div>
      ) : (
        <button className="btn-secondary btn-sm" onClick={() => send()} disabled={phase === 'sending'}>
          {phase === 'sending' ? 'Sending…' : 'Verify email'}
        </button>
      )}
      {error && <div className="acct-inline-error" role="alert">{error}</div>}
    </div>
  );
};

export default VerifyEmailInline;
